import { apiCall } from '../../../services/apiUtil';

export const badmintonGameAPI = {
  getById: async (id) => {
    return apiCall(`/games/${id}`);
  },

  getByEventId: async (eventId) => {
    return apiCall(`/games/event/${eventId}`);
  },

  setInitialServe: async (gameId, servingPlayer, servingPlayerId) => {
    return apiCall(`/games/${gameId}/badminton/serve`, {
      method: 'PATCH',
      body: JSON.stringify({ servingPlayer, ...(servingPlayerId != null && { servingPlayerId }) }),
    });
  },

  recordRally: async (gameId, rallyData) => {
    const payload = {
      pointWinner: rallyData.pointWinner,
      ...(rallyData.shotType            != null && { shotType:             rallyData.shotType }),
      ...(rallyData.pointWinnerPlayerId != null && { pointWinnerPlayerId:  rallyData.pointWinnerPlayerId }),
      ...(rallyData.pointLoserPlayerId  != null && { pointLoserPlayerId:   rallyData.pointLoserPlayerId }),
    };
    return apiCall(`/games/${gameId}/badminton/rallies`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  undoLastRally: async (gameId) => {
    return apiCall(`/games/${gameId}/badminton/rallies/last`, {
      method: 'DELETE',
    });
  },

  completeGame: async (gameId, gameData) => {
    return apiCall(`/games/${gameId}/badminton/game-complete`, {
      method: 'POST',
      body: JSON.stringify(gameData),
    });
  },

  complete: async (gameId, completionData) => {
    return apiCall(`/games/${gameId}/complete`, {
      method: 'POST',
      body: JSON.stringify(completionData || {}),
    });
  },

  delete: async (gameId) => {
    return apiCall(`/games/${gameId}`, {
      method: 'DELETE',
    });
  },

  resetGame: async (gameId) => {
    return apiCall(`/games/${gameId}/badminton/reset`, {
      method: 'POST',
    });
  },

  pause: async (gameId, { reason, durationMinutes }) => {
    return apiCall(`/games/${gameId}/pause`, {
      method: 'POST',
      body: JSON.stringify({ reason, durationMinutes }),
    });
  },

  resume: async (gameId) => {
    return apiCall(`/games/${gameId}/resume`, {
      method: 'POST',
    });
  },
};

export default badmintonGameAPI;
